<app-nav />
<router-outlet />
<app-upload-panel />
<p-toast position="bottom-right" />
<p-confirmdialog styleClass="app-confirm-dialog" />
